import { updateReviewStatus } from "api/apis";
import React from "react";
import { Card, Form } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const ReviewsRating = ({ reviews, setReviews }: any) => {
  const statusOptions = ["Approved", "Rejected", "Waiting Approval"];

  const handleStatusChange = async (id: string, newStatus: string) => {
    try {
      await updateReviewStatus(id, newStatus);

      setReviews((prev: any) => {
        if (newStatus === "Rejected") {
          return prev.filter((review: any) => review._id !== id);
        }
        return prev.map((review: any) =>
          review._id === id ? { ...review, status: newStatus } : review
        );
      });
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  return (
    <>
      {(!reviews || reviews.length === 0) ? (
        <div className="text-center text-muted my-5">
          <h5>No reviews found</h5>
        </div>
      ) : (
        <ResponsiveMasonry
          className="row mx-1"
          columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
        >
          <Masonry>
            {reviews.map((item: any, index: number) => (
              <Card className="mx-2 my-2" key={index}>
                <Card.Body>
                  <img
                    src={item?.product?.images?.[0]}
                    alt="product"
                    className="avatar-sm rounded"
                  />

                  <h5 className="mb-1 mt-3">
                    {`Product Name: ${item?.product?.name}`}
                  </h5>

                  <div className="text-warning mb-2">
                    {[...Array(item.rating)].map((_, i) => (
                      <i className="ri-star-s-fill" key={i}></i>
                    ))}
                  </div>

                  <p className="text-muted fs-15 mb-2">
                    {`Review : ${item?.review}`}
                  </p>
                  <p className="text-muted fs-15 mb-2">
                    {`User Name: ${item?.user?.firstName} ${item?.user?.lastName}`}
                  </p>
                  <p className="text-muted fs-15 mb-2">
                    {`User Email: ${item?.user?.email}`}
                  </p>

                  <Form.Select
                    value={item.status}
                    onChange={(e) =>
                      handleStatusChange(item._id, e.target.value)
                    }
                  >
                    {statusOptions.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Select>
                </Card.Body>
              </Card>
            ))}
          </Masonry>
        </ResponsiveMasonry>
      )}
    </>
  );
};

export default ReviewsRating;

